import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=7ce3d69c"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ce3d69c')) {
      api.createRecord('7ce3d69c', component.options)
    } else {
      api.reload('7ce3d69c', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=7ce3d69c", function () {
      api.rerender('7ce3d69c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/point/edit.vue"
export default component.exports